import '@babel/polyfill'
import 'nodelist-foreach-polyfill'
import Swiper from 'swiper'

const selectors = {
  el: '.js-customersNoImageCarousel',
  pagination: '.c-customers-no-image__pagination',
  bullet: '.swiper-pagination-bullet'
}

export default () => {
  window.customersNoImageCarousel = new Swiper(selectors.el, {
    effect: 'fade',
    slidesPerView: 1,
    pagination: {
      el: selectors.pagination,
      clickable: true,
      type: 'bullets',
      renderBullet: function (index, className) {
        return '<span class="' + className + '">0' + (index + 1) + '</span>'
      }
    },
  })
}
